import React, { ReactElement } from 'react';
import { Step } from '../../step';

import style from './style.module.scss';
import { Button } from '../../ui/button';

import { ReactComponent as FirstStep } from '../../../images/steps/first.svg';
import { ReactComponent as SecondStep } from '../../../images/steps/second.svg';
import { ReactComponent as ThirdStep } from '../../../images/steps/third.svg';
import { Link } from '../../ui/link';

export const StepsSection = (): ReactElement => (
  <section className={style.steps}>
    {/* @ts-ignore */ }
    <Step className={style.step} footer={<a href="https://chrome.google.com/webstore/detail/doortome/pioadgeiibbhdmfaannpnbffkmceboki?hl=ru&"><Button className={style.button}>Установить</Button></a>} description="Для начала вам необходимо установить наше расширение из магазина Google Chrome." title="Установить расширение">
      <FirstStep className={style.stepImage} />
    </Step>
    <Step reversed className={style.step} description="Откройте фильм на любом медиасервисе. У всех вас должен быть доступ к просмотру." title="Выберите фильм">
      <div className={style.secondStep}>
        <SecondStep className={style.secondStepImage} />
      </div>
    </Step>
    <Step className={style.step} description="Создайте сессию, она автоматически привяжется к текущему видео. После этого друзьям останется только присоединиться к вашей сесcии." title="Создайте сессию">
      <ThirdStep className={style.stepImage} />
    </Step>
  </section>
);
